/*******************************************************************************
 * Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>
 *
 * This file BasketToastr.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * BasketToastr.js can not be copied and/or distributed
 * without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
 ******************************************************************************/

export default {
    created(){
    },
    data() {
        return {
            toastr_last: {},
            toastr_options: {
                newestOnTop: true,
                progressBar: true,
                timeOut: 6000,
                positionClass: "toast-top-right",
                showMethod: 'slideDown',
                hideMethod: 'fadeOut',
                showDuration: 100,
            },
        }
    },
    mounted(){
    },
    methods: {
        showToastr(type, params) {
            let self = this,
                title = ('title' in params) ? `<div>${params.title}</div>` : '',
                message = `<div class="p-3">${params.message}</div>`;

            toastr.options = self.toastr_options;

            self.toastr_last = toastr[type](
                `${title}
		            ${message}`
            );
        },
        clearToastr(last) {
            toastr.clear(last);
        },
    },
};


// WEBPACK FOOTER //
// ./resources/assets/js/components/basket/BasketToastr.js